import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function Cart() {
  const { items, remove, update, total, clear } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div style={{ paddingTop: 64, minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20, textAlign: 'center', padding: '64px 32px' }}>
        <div style={{ fontFamily: 'Bomber Dreams', fontSize: 80, color: 'var(--border)', lineHeight: 1 }}>
          0
        </div>
        <div style={{ fontFamily: 'DM Mono', fontSize: 12, letterSpacing: 3, color: 'var(--muted)', textTransform: 'uppercase' }}>
          Cart is empty
        </div>
        <Link to="/" style={{
          fontFamily: 'DM Mono', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase',
          padding: '10px 24px', borderRadius: 6, background: 'var(--teal)', color: '#000',
        }}>
          Back to Shop
        </Link>
      </div>
    );
  }

  return (
    <div style={{ paddingTop: 64 }}>
      <section style={{ padding: '60px 32px 80px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>

          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div style={{
              fontFamily: 'DM Mono', fontSize: 18, letterSpacing: 4,
              color: 'var(--teal)', textTransform: 'uppercase', marginBottom: 12,
            }}>
              OG-TECH LLC
            </div>
            <h1 style={{ fontFamily: 'Bomber Dreams', fontSize: 'clamp(40px, 6vw, 64px)', letterSpacing: 2 }}>
              Your Cart
            </h1>
          </div>

          {/* Items */}
          <div style={{ marginBottom: 32 }}>
            {items.map(item => (
              <div key={`${item.id}-${item.variant}`} style={{
                display: 'flex', gap: 20, alignItems: 'center',
                padding: '20px 0', borderBottom: '1px solid var(--border)',
              }}>
                <div style={{
                  width: 72, height: 72, flexShrink: 0,
                  background: 'var(--card)', borderRadius: 8,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <img src={item.image} alt={item.name}
                    style={{ width: '70%', height: '70%', objectFit: 'contain' }} />
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: 'Bomber Dreams', fontSize: 18, letterSpacing: 1, marginBottom: 4 }}>
                    {item.name}
                  </div>
                  <div style={{ fontFamily: 'DM Mono', fontSize: 11, color: 'var(--muted)', letterSpacing: 1 }}>
                    {item.variant}
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{
                    display: 'flex', alignItems: 'center',
                    border: '1px solid var(--border)', borderRadius: 6, overflow: 'hidden',
                  }}>
                    <button onClick={() => update(item.id, item.variant, item.qty - 1)} style={{
                      width: 32, height: 36, background: 'transparent',
                      border: 'none', color: 'var(--muted)', fontSize: 16, cursor: 'pointer',
                    }}>−</button>
                    <span style={{
                      width: 32, textAlign: 'center',
                      fontFamily: 'DM Mono', fontSize: 13, color: 'var(--text)',
                    }}>{item.qty}</span>
                    <button onClick={() => update(item.id, item.variant, item.qty + 1)} style={{
                      width: 32, height: 36, background: 'transparent',
                      border: 'none', color: 'var(--muted)', fontSize: 16, cursor: 'pointer',
                    }}>+</button>
                  </div>

                  <div style={{
                    fontFamily: 'Bomber Dreams', fontSize: 20,
                    color: 'var(--teal)', minWidth: 64, textAlign: 'right',
                  }}>
                    ${(item.price * item.qty).toFixed(2)}
                  </div>

                  <button onClick={() => remove(item.id, item.variant)} style={{
                    background: 'transparent', border: 'none',
                    color: 'var(--muted)', fontSize: 18, cursor: 'pointer',
                    padding: '0 4px',
                  }}>✕</button>
                </div>
              </div>
            ))}
          </div>

          {/* Total + Checkout */}
          <div style={{
            background: 'var(--card)', border: '1px solid var(--border)',
            borderRadius: 12, padding: 28,
          }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              marginBottom: 24,
            }}>
              <span style={{ fontFamily: 'DM Mono', fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>
                Total
              </span>
              <span style={{ fontFamily: 'Bomber Dreams', fontSize: 36, color: 'var(--teal)' }}>
                ${total.toFixed(2)}
              </span>
            </div>

            <button
              onClick={() => navigate('/checkout')}
              style={{
                width: '100%', fontFamily: 'DM Mono', fontSize: 14, letterSpacing: 2,
                textTransform: 'uppercase', padding: '14px', borderRadius: 8,
                background: 'var(--pink)', color: '#000', border: 'none',
                cursor: 'pointer', marginBottom: 12,
              }}
            >
              Checkout →
            </button>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Link to="/" style={{
                fontFamily: 'DM Mono', fontSize: 11, letterSpacing: 2,
                textTransform: 'uppercase', color: 'var(--muted)',
              }}>
                ← Continue Shopping
              </Link>
              <button onClick={clear} style={{
                background: 'transparent', border: 'none',
                fontFamily: 'DM Mono', fontSize: 11, letterSpacing: 2,
                textTransform: 'uppercase', color: 'var(--muted)', cursor: 'pointer',
              }}>
                Clear Cart
              </button>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
